import { render, staticRenderFns } from "./TraxAccountAuthRegister.vue?vue&type=template&id=f71bd330"
import script from "./TraxAccountAuthRegister.vue?vue&type=script&lang=js"
export * from "./TraxAccountAuthRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports